<template>
  <v-navigation-drawer
    id="side-drawer"
    app
    right
    temporary
    width="480"
    v-model="drawer.visible"
    :height="`calc( 100vh - ${drawerTop}px`"
    :style="`top: ${drawerTop}px;`"
    :touchless="!drawer.visible"
  >
    <!-- Content -->
    <review-drawer v-if="drawer.status === 'review'" :review="drawer.data"></review-drawer>

    <edit-favorites-drawer v-else-if="drawer.status === 'edit-favorites'" :data="drawer.data"></edit-favorites-drawer>

    <v-alert v-else elevation="5" type="error">An Error Occured</v-alert>
  </v-navigation-drawer>
</template>

<style scoped>
#side-drawer {
  max-width: calc(100% - 40px);
  padding-top: env(safe-area-inset-top, 0);
}

#side-drawer .v-card {
  min-height: 100%;
}
</style>

<script>
import { mapMutations } from "vuex";

import ReviewDrawer from "./drawers/review-drawer.vue";
import EditFavoritesDrawer from "./drawers/edit-favorites-drawer.vue";

export default {
  name: "side-drawer",

  components: {
    "review-drawer": ReviewDrawer,
    "edit-favorites-drawer": EditFavoritesDrawer,
  },

  computed: {
    drawer() {
      return this.$store.state.drawer;
    },

    drawerTop() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) return 56;
      else return 64;
    },
  },

  methods: {
    ...mapMutations(["closeDrawer"]),
  },
};
</script>
